import { FORCE_ACTIONS } from '../actions';
import { ForceState } from '../state';

export const updateForceReducer = (state: ForceState, { force }: ReturnType<typeof FORCE_ACTIONS.UPDATE_FORCE>) => {
    return {
        ...state,
        forces: state.forces.map((f) => {
            if (force.id !== f.id) {
                return f;
            }

            // Merge the update into the existing force
            const merged = { ...f, ...force };

            // Preserve the newer updatedAt timestamp to prevent sync conflicts.
            // This handles the case where application code calls update with a force
            // that has a stale timestamp (e.g., captured before a recent upload completed).
            if (f.updatedAt && force.updatedAt) {
                merged.updatedAt = Math.max(f.updatedAt, force.updatedAt);
            }

            return merged;
        })
    };
};
